// extracted by mini-css-extract-plugin
export var carrierTab = "_4j-0";
export var carrierTabActive = "_4j-1 _4j-0";
export var carrierTabInactive = "_4j-2 _4j-0";
export var carrierTabLabel = "_4j-3";
export var carrierTabLabelActive = "_4j-4 _4j-3";
export var carrierTabLabelInactive = "_4j-5 _4j-3";
export var carrierTabPercentage = "_4j-6";
export var carrierTabPercentageActive = "_4j-7 _4j-6";
export var carrierTabPercentageInactive = "_4j-8 _4j-6";
export var carrierTabWinnable = "_4j-9";
export var carrierTabWinnableActive = "_4j-a _4j-9";
export var carrierTabWinnableInactive = "_4j-b _4j-9";
export var comparisonContainer = "_4j-d";
export var missingRateButton = "_4j-n";
export var missingRateButtonActive = "_4j-o _4j-n";
export var missingRateButtonInactive = "_4j-p _4j-n";
export var missingRateButtonLabel = "_4j-q";
export var missingRateButtonLabelActive = "_4j-r _4j-q";
export var missingRateButtonLabelInactive = "_4j-s _4j-q";
export var sidebar = "_4j-c";
export var strategyButton = "_4j-e";
export var strategyButtonActive = "_4j-f _4j-e";
export var strategyButtonDescription = "_4j-k";
export var strategyButtonDescriptionActive = "_4j-l _4j-k";
export var strategyButtonDescriptionInactive = "_4j-m _4j-k";
export var strategyButtonInactive = "_4j-g _4j-e";
export var strategyButtonLabel = "_4j-h";
export var strategyButtonLabelActive = "_4j-i _4j-h";
export var strategyButtonLabelInactive = "_4j-j _4j-h";
export var unitToggleButton = "_4j-t";
export var unitToggleButtonActive = "_4j-u _4j-t";
export var unitToggleButtonInactive = "_4j-v _4j-t";
export var unitToggleButtonLabel = "_4j-w";
export var unitToggleButtonLabelActive = "_4j-x _4j-w";
export var unitToggleButtonLabelInactive = "_4j-y _4j-w";